import React from 'react';
import { Link } from 'react-router-dom';

export default function Nav() {
  return (
    <>
      <section className='bg-[rgb(240_240_253_/_98%)]
       h-[8vh] mb-4 flex justify-evenly items-center fixed w-screen md:w-full overflow-hidden  md:static z-50'>

    <div className='  text-center mx-4 flex justify-evenly items-center'>
<h3 className='text-2xl md:text-4xl font-semibold md:font-bold inline-block bg-gradient-to-r from-black to-yellow-400 via-red-500 bg-clip-text text-transparent'>D.B</h3>
   <Link to='/'>
   <button type="button" className='p-1 bg-red-700 m-2 border-2 border-white rounded-lg active:bg-transparent
    '>Home</button>

   </Link>

    
    </div>
    <div className="flex justify-evenly w-full text-2xl md:text-3xl font-semibold md:font-bold ">
      <a href="https://www.facebook.com/bikash.thakur.584632" target='_blank' className=' inline-block text-blue-500 '>
        
        <i className="fa-brands fa-facebook"></i>


      </a>
      <a href="https://www.instagram.com/bikashthakur8387/" target='_blank' className='
      inline-block bg-gradient-to-r from-red-500 to-pink-400 bg-clip-text text-transparent
      '>
        <i className="fa-brands fa-square-instagram"></i>

      </a>
      <a href="https://www.tiktok.com/@bikashthakur53" target='_blank'>
                        <i className="fa-brands fa-tiktok"></i>

      </a>
      <a href=" https://wa.me/9779746672410" target='_blank' className='text-green-500'> 
            <i className="fa-brands fa-square-whatsapp"></i>

      </a>
    </div>


      </section>
    </>
  )
}
